<template>
    <section class="page-section bg-light" id="support">
        <div class="py-5">
            <div class="container">
                <div class="text-center">
                    <h2 class="section-heading text-uppercase">Sponsors</h2>
                    <h3>You can support us too with PayPal.  Click Donate and select "First Robotics".</h3>
                        <form action="https://www.paypal.com/donate" method="post" target="_donate">
                            <input type="hidden" name="hosted_button_id" value="NR8SF5LHQW45E" />
                            <input type="image" src="https://www.paypalobjects.com/en_US/i/btn/btn_donate_LG.gif" border="0" name="submit" title="Select First Robotics" alt="Donate with PayPal button" />
                            <img alt="" border="0" src="https://www.paypal.com/en_US/i/scr/pixel.gif" width="1" height="1" />
                        </form>
                </div>
                <div class="row align-items-center">
                    <div
                        v-for="sponsor in sponsors" 
                        v-bind:key="sponsor.name"
                        class="col-sm-6 p-4">
                        <a href="#!"><img class="img-fluid" :style="{ width: sponsor.maxWidth || '100%', height: 'auto' }" :src="sponsor.logo" alt="..." :aria-label="sponsor.name" /></a>
                    </div>
                </div>
                
            </div>
        </div>
    </section>

</template>

<script setup lang="ts">
import { sponsors } from '@/data/sponsors'
</script>